import { Suspense } from 'react';

/* eslint-disable react/require-default-props */
type ImageProps = {
  src: string | undefined;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
};
function Image({ src, alt, width, height, className }: ImageProps) {
  if (!src) {
    return null;
  }

  const onError = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const e = event;
    e.currentTarget.src = `${process.env.PUBLIC_URL}/assets/images/default-image.png`;
  };
  return (
    <Suspense>
      <img
        className={`table-img ${className}`}
        alt={alt}
        src={src}
        onError={onError}
        width={width}
        height={height}
      />
    </Suspense>
  );
}

export default Image;
